import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { COLOR } from '@src/styles/color';

const StyledUploadAndForm = styled(Box)`
  display: flex;
  max-width: 1280px;
  height: 100%;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  justify-content: center;
`;

const LeftSection = styled(Box)`
  display: flex;
  max-width: 512px;
  padding: 40px;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
  max-height: 100%;
  min-height: 0;
  flex-shrink: 0;
  overscroll-behavior: contain;
  box-sizing: border-box;
  border-right: 1px solid ${COLOR.secondary[16]};
  @media (min-width: 1440px) {
    padding-top: 80px;
  }
`;

const RightSection = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
  padding: 40px 40px 0 40px;
  max-height: 100%;
  min-height: 0;
  box-sizing: border-box;
  overflow: hidden;
  @media (min-width: 1440px) {
    padding-top: 80px;
  }
`;

export { StyledUploadAndForm, LeftSection, RightSection };
